"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogError = void 0;
// Generic wrapper for error handling.
// TODO: send to logging framework

const LogError = _ref => {
  let {
    message,
    severity = 'log',
    error
  } = _ref;
  // eslint-disable-next-line no-console
  console[severity](message, error);
};
exports.LogError = LogError;